import { Link } from "react-router-dom"
import { Button } from "@mui/material"
import dayjs from "dayjs"

import { formatDocumentParts } from "../../../utils/format-document"
import { OrderRow } from "../Orders/orderTypes"
import { OrderDetailCard, OrderDetailField } from "./OrderDetailCard"

type OrderClientCardProps = {
  order: OrderRow
}

export function OrderClientCard({ order }: OrderClientCardProps) {
  const document = formatDocumentParts(order.document)

  return (
    <OrderDetailCard title="Dados do Cliente">
      <OrderDetailField label="Nome" value={order.client} />
      <OrderDetailField label={document.label} value={document.value} />
      <OrderDetailField label="E-mail" value={order.email} />
      <OrderDetailField label="Telefone" value={order.clientPhone} />
      <OrderDetailField label="Endereço" value={order.clientAddress} />
      <OrderDetailField label="Cliente desde" value={dayjs(order.clientSince).format('DD/MM/YYYY')} />

      <Button
        component={Link}
        to={`/pedidos?search=${encodeURIComponent(order.client)}`}
        variant="text"
      >
        Histórico de Pedidos
      </Button>
    </OrderDetailCard>
  )
}
